{
  "name": "@cdktn/commons",
  "version": "0.24.0",
  "publishConfig": {
    "access": "public"
  },
  "description": "CDK Terrain Common utilities",
  "scripts": {
    "build": "tsc",
    "watch": "tsc -w",
    "watch-preserve-output": "tsc -w --preserveWatchOutput",
    "test:update": "jest -u",
    "package": "./package.sh",
    "dist-clean": "rm -rf dist",
    "package:js": "./package.sh"
  },
  "main": "build/index.js",
  "types": "build/index.d.ts",
  "nx": {
    "tags": [
      "unit-test"
    ]
  },
  "repository": {
    "type": "git",
    "url": "git://github.com/open-constructs/cdk-terrain.git",
    "directory": "packages/@cdktn/commons"
  },
  "author": {
    "name": "OpenConstructs",
    "url": "https://github.com/open-constructs"
  },
  "keywords": [
    "cdk",
    "cdktf",
    "cdktn",
    "terraform"
  ],
  "license": "MPL-2.0",
  "dependencies": {
    "@sentry/node": "7.120.4",
    "cdktn": "workspace:*",
    "ci-info": "4.4.0",
    "codemaker": "1.128.0",
    "cross-spawn": "7.0.6",
    "follow-redirects": "1.16.0",
    "fs-extra": "11.3.6",
    "log4js": "6.9.1",
    "semver": "7.8.5",
    "strip-ansi": "6.0.1",
    "validator": "13.15.35"
  },
  "devDependencies": {
    "@types/cross-spawn": "6.0.6",
    "@types/follow-redirects": "1.14.4",
    "@types/fs-extra": "11.0.4",
    "@types/semver": "7.7.1",
    "@types/validator": "13.15.10",
    "tsc-files": "1.1.4",
    "typescript": "^5.0.4"
  },
  "lint-staged": {
    "src/**/*.{ts,tsx}": "tsc-files ambient.d.ts --noEmit"
  }
}
